import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-grey-lighter min-h-screen flex flex-col"
}
const _hoisted_2 = { class: "container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2" }
const _hoisted_3 = { class: "bg-white px-6 py-8 rounded shadow-md text-black w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-8 text-3xl text-center" }, "パスワードリセット", -1)
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " メールアドレス ", -1)
const _hoisted_7 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-600",
  role: "alert"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_12 = {
  key: 1,
  class: "bg-grey-lighter min-h-screen flex flex-col"
}
const _hoisted_13 = { class: "container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2" }
const _hoisted_14 = { class: "bg-white px-6 py-8 rounded shadow-md text-black w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-8 text-3xl text-center" }, "確認コードの入力", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "ご入力のメールアドレスに送信された確認コードと新しいパスワードを入力してください。", -1)
const _hoisted_17 = { class: "mt-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " 確認コード ", -1)
const _hoisted_19 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_21 = { class: "mt-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " パスワード ", -1)
const _hoisted_23 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-600",
  role: "alert"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)

import { ref } from "vue";
import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";
import { Auth } from "aws-amplify";
import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";
// import { Auth } from "aws-amplify";

// export default class ResetPasswordView extends Vue {
const store = useStore();
const router = useRouter();

const mode = ref<string>("profile");

const formSchema = yup.object({
  email: yup.string().email().required("必須項目です"),
  password: yup.string().required("必須項目です"),
  new_password: yup.string().required("必須項目です"),
  confirm_code: yup.string().required("必須項目です"),
});

useForm({ validationSchema: formSchema });

const email_field = useField<string>("email");
const password_field = useField<string>("password");
const new_password_field = useField<string>("new_password");
const confirm_code_field = useField<string>("confirm_code");

const email = email_field.value;
const email_error = email_field.errorMessage;

const password = password_field.value;
const password_error = password_field.errorMessage;

const new_password = new_password_field.value;
const new_password_error = new_password_field.errorMessage;

const confirm_code = confirm_code_field.value;
const confirm_code_error = confirm_code_field.errorMessage;

//   email = "wrgbh447@gmail.com";
//   email_error = "";

//   password = "1qaz2wsX@";
//   password_error = "";

const forget_password_error = ref<string>("");

//   confirm_code = "";
//   confirm_code_error = "";

const submit_forget_password_error = ref<string>("");

const validateProfile = async (): Promise<boolean> => {
  // console.log(`validteProfile()`);

  forget_password_error.value = "";

  await email_field.validate();

  return !email_error.value;
};

const doSendCconfirmCode = () => {
  // console.log(`doLogin(${email}, ${password})`);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validateProfile();

      if (!valid) {
        return;
      }

      const forgetPasswordResult = await Auth.forgotPassword(email.value);

      // console.log(forgetPasswordResult);

      mode.value = "submit";
    } catch (err: any) {
      // console.log(err.code);
      forget_password_error.value =
        "確認コードの送信に失敗しました。メールアドレス確認して再度登録してください。";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const validateConfirmCode = async (): Promise<boolean> => {
  // console.log(`validteConfirmCode()`);

  await password_field.validate();
  await confirm_code_field.validate();

  return !password_error.value && !confirm_code_error.value;
};

const doSubmitForgetPassword = () => {
  // console.log(`doSubmitForgetPassword(${email}, ${password})`);
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validateConfirmCode();

      if (!valid) {
        return;
      }

      const confirmSignupResult = await Auth.forgotPasswordSubmit(
        email.value,
        confirm_code.value,
        password.value
      );

      // console.log(confirmSignupResult);

      router.replace("/login");
    } catch (err: any) {
      submit_forget_password_error.value =
        "パスワードのリセットに失敗しました。入力した確認コードを確認してください。";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (mode.value == 'profile')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    autocomplete: "email",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(email_error) }]),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(email)]
                  ])
                ]),
                (_unref(email_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", null, _toDisplayString(_unref(email_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "mt-6 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                onClick: _withModifiers(doSendCconfirmCode, ["prevent"])
              }, " パスワードリセット ", 8, _hoisted_9),
              (forget_password_error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", null, _toDisplayString(forget_password_error.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (mode.value == 'submit')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("form", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    autocomplete: "email",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(confirm_code_error) }]),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(confirm_code) ? (confirm_code).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(confirm_code)]
                  ])
                ]),
                (_unref(confirm_code_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", null, _toDisplayString(_unref(confirm_code_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(password_error) }]),
                    placeholder: "パスワード",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(password) ? (password).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(password)]
                  ])
                ]),
                (_unref(password_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", null, _toDisplayString(_unref(password_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "mt-6 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                onClick: _withModifiers(doSubmitForgetPassword, ["prevent"])
              }, " 確認コードの送信 ", 8, _hoisted_25),
              (submit_forget_password_error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, _toDisplayString(submit_forget_password_error.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})